<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" @stored="storePermission">
                    <template v-slot:action="{ item }">
                        <v-btn class="mr-2" depressed small @click.stop="readPermission(item)" color="info">閲覧</v-btn>
                        <v-btn class="mr-2" depressed small @click.stop="updatedPermission(item)" color="primary">編集</v-btn>
                        <v-btn class="mr-2" depressed small @click.stop="deletePermission(item)" color="error">削除</v-btn>
                    </template>
                </custom-data-table>
            </v-col>
        </v-row>
        <v-row justify="center">
            <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
                @deleted="deleted" @canceled="dialogCancel"/>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="readDialogDrawer" persistent :max-width="readDialogMaxWith">
            <v-card>
                <v-card-title class="headline">{{readDialogTitle}}</v-card-title>
                <v-card-text>
                    <v-divider/>
                    <v-data-table :headers="readDialogHeaders" :items="readDialogItems" hide-default-footer disable-pagination dense/>
                    <v-divider/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="grey lighten-1" @click.stop="readDialogDrawer=!readDialogDrawer">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import PermissionsApi from "@/api/permissions-api";

  export default {
    name: "PermissionMaster",
    components: {
      CustomDataTable,
      CustomDialog
    },
    props: ["user"],
    data: () => ({
        // ユーザー一覧テーブル
        loading: false,
        tableName: "権限情報",
        headers: [
            { text: "権限名称", value: "permission_name" },
            { text: "アクション", value: "action" }
        ],
        items: [],

        // 削除ダイアログ
        dialogMaxWith: 500,
        dialogTitle: "",
        dialogItems: [],
        dialogDrawer: false,
        deleteId: null,

        // 閲覧ダイアログ
        readDialogMaxWith: 600,
        readDialogTitle: "",
        readDialogHeaders: [
            { text: "画面名", value: "name" },
            { text: "閲覧", value: "read", align: "center" },
            { text: "作成/編集", value: "update", align: "center" },
            { text: "削除", value: "delete", align: "center" },
            { text: "全データ表示", value: "display", align: "center" }
        ],
        readDialogItems: [],
        readDialogDrawer: false
    }),
    created() {
        this.initialize();
    },
    methods: {
        isLoading() {
            this.loading = !this.loading;
            this.$emit("loading", this.loading);
        },
        initialize() {
            this.isLoading();
            this.permissionsApi = new PermissionsApi();
            const promise = this.permissionsApi.list();
            promise.then((response) => {
                this.items = response.data.body.permission_list;
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if(error.response){
                    this.$emit("error",error.response.data.message);
                }else{
                    this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        },
        readPermission(item) {
            this.readDialogTitle = item.permission_name;
            this.readDialogItems = [];
            for (var key in item.config) {
                this.readDialogItems.push({
                    name: item.config[key].name,
                    read: item.config[key].read ? "✔" : "",
                    update: item.config[key].update ? "✔" : "",
                    delete: item.config[key].delete ? "✔" : "",
                    display: item.config[key].display ? "✔" : ""
                });
            }
            this.readDialogDrawer = true;
        },
        storePermission() {
            this.$router.push({ name: 'PermissionMasterEntry' });
        },
        updatedPermission(item) {
            this.$router.push({ name: 'PermissionMasterEdit', params: { id: item.id } });
        },
        deletePermission(item) {
            this.deleteId = item.id;
            this.dialogTitle = '削除しますか？';
            this.dialogItems = [
                { name: "権限名称", value: item.permission_name },
            ];
            this.dialogDrawer = true;
        },
        dialogCancel() {
            this.dialogDrawer = false;
        },
        deleted() {
            this.isLoading();
            const promise = this.permissionsApi.delete(this.deleteId);
            promise.then((response) => {
                this.items = this.items.filter((item) => {
                    return (item.id !== this.deleteId);
                });
                this.deleteId = null;
                this.dialogDrawer = false;
                this.$emit('success', response.data.message);
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if(error.response){
                    this.$emit("error",error.response.data.message);
                }else{
                    this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        }
    }
  };
</script>
